<script setup>
const props = defineProps({
  open: { type: Boolean, default: false },
  asset: { type: Object, default: null },
})
defineEmits(['update:open'])
</script>

<template>
  <UModal
    :open="open"
    :title="asset?.filename"
    :ui="{ content: 'max-w-3xl' }"
    @update:open="$emit('update:open', $event)"
  >
    <template #body>
      <video
        v-if="asset"
        :key="asset.id"
        :src="asset.video_url"
        :poster="asset.thumb_url"
        controls
        autoplay
        class="w-full rounded-lg bg-black"
      />
    </template>
  </UModal>
</template>
